import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
	MISSION_TYPE_QUALIFICATION_DEMAND,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Parcours } from 'src/app/shared/models/services-aide-emploi/parcours';
import { FormationsModalAjoutFormComponent } from '../../formations/modal/formations-modal-ajout-form/formations-modal-ajout-form.component';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { SelectionQualificatorComponent } from '../selection-qualificator/selection-qualificator.component';

@Component({
	selector: 'app-detail-parcours',
	templateUrl: './detail-parcours.component.html',
	styleUrls: ['./detail-parcours.component.scss']
})
export class DetailParcoursComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	parcours: Parcours = null;

	labelIntervention: string;

	isFormReadOnly = true;

	ajoutFormationModalref: BsModalRef;
	qualificationMissionType: MissionType;

	selectionQualificatorModalref: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.getParcours();
	}

	getParcours(): void {
		const id = this.route.snapshot.paramMap.get('id');
		this.facade.parcoursService
			.getParcoursById(id)
			.subscribe((parcours: Parcours) => {
				this.parcours = parcours;
			});
	}

	createMissionQualification(): void {
		const initialState = {
			//codeMissionType: MISSION_TYPE_QUALIFICATION_DEMAND,
			//parcoursId: this.parcours.id
		};
		this.ajoutFormationModalref = this.modalService.show(
			FormationsModalAjoutFormComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutFormationModalref.onHide.subscribe((reason: string | any) => {
			this.getParcours();
		});
	}

	openModalSelectionQualificator(): void {
		const initialState = {
			parcoursId: this.parcours.id
			// missionQualification: this.parcours.missionQualification
		};
		this.selectionQualificatorModalref = this.modalService.show(
			SelectionQualificatorComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutFormationModalref.onHide.subscribe((reason: string | any) => {
			this.getParcours();
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/parcours/list']);
	}
}
